// Author Lin
// Date 2022-04-06 21:37:10

class SithMesInventoryChangeMaterialProject {
        constructor({
                id = null,
                changeType = '',
                financialRequired = '',
                target = '',
                financialLogin = '',
                financialApprovalTime = '',
                logLogin = '',
                logApprovalTime = '',
                status = '',
                workOrderCode = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.changeType = changeType;
            this.financialRequired = financialRequired;
            this.target = target;
            this.financialLogin = financialLogin;
            this.financialApprovalTime = financialApprovalTime;
            this.logLogin = logLogin;
            this.logApprovalTime = logApprovalTime;
            this.status = status;
            this.workOrderCode = workOrderCode;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesInventoryChangeMaterialProject();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'changeType',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.changeType',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'SO转SO' },
                                    { value: '2', text: 'WBS转SO' },
                                    { value: '3', text: 'SO转大库' },
                                    { value: '4', text: '大库转SO' },
                                    { value: '5', text: '大库转WBS' },
                                    { value: '6', text: '寄售转大库' },
                                    { value: '7', text: 'WBS转大库' },
                                    { value: '8', text: 'SO转WBS' },
                                    { value: '9', text: 'WBS转WBS' },
                                    { value: '10', text: '大库转供应商' }
                    ]
                }
                },
                {
                key: 'financialRequired',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.financialRequired',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'target',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.target',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'financialLogin',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.financialLogin',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'financialApprove',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.financialApprove',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'financialApprovalTime',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.financialApprovalTime',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'logLogin',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.logLogin',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'logApprove',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.logApprove',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'logApprovalTime',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.logApprovalTime',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'status',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.status',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'workOrderCode',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.workOrderCode',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'statusName',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.grid.statusName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            changeTypeFilter : '',
            financialRequiredFilter : '',
            targetFilter : '',
            financialLoginFilter : '',
            financialApprovalTimeRteFilter : '',
            financialApprovalTimeLteFilter : '',
            logLoginFilter : '',
            logApprovalTimeRteFilter : '',
            logApprovalTimeLteFilter : '',
            statusFilter : '',
            workOrderCodeFilter : '',
            workflowQueryTypeFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'changeTypeFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.changeType',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: 'SO转SO' },
                        { value: '2', text: 'WBS转SO' },
                        { value: '3', text: 'SO转大库' },
                        { value: '4', text: '大库转SO' },
                        { value: '5', text: '大库转WBS' },
                        { value: '6', text: '寄售转大库' },
                        { value: '7', text: 'WBS转大库' },
                        { value: '8', text: 'SO转WBS' },
                        { value: '9', text: 'WBS转WBS' },
                        { value: '10', text: '大库转供应商' }
                    ]
                }
                },
                {
                key: 'financialRequiredFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.financialRequired',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'targetFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.target',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'financialLoginFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.financialLogin',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'financialApprovalTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.financialApprovalTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'financialApprovalTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.financialApprovalTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'logLoginFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.logLogin',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'logApprovalTimeRteFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.logApprovalTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'logApprovalTimeLteFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.logApprovalTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'statusFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.status',
                disabled: false,
                form: {
                type: 'entitySelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'emActProcessStatus'
                    ,showLabelSelectOne: true
                            ,selectFilter:{processBusinessEntityFilter:'SithMesInventoryChangeMaterialProject',statusFilter:1}
                }
                },
                {
                key: 'workOrderCodeFilter',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.filter.workOrderCode',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'changeType',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.changeType',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: 'SO转SO' },
                        { value: '2', text: 'WBS转SO' },
                        { value: '3', text: 'SO转大库' },
                        { value: '4', text: '大库转SO' },
                        { value: '5', text: '大库转WBS' },
                        { value: '6', text: '寄售转大库' },
                        { value: '7', text: 'WBS转大库' },
                        { value: '8', text: 'SO转WBS' },
                        { value: '9', text: 'WBS转WBS' },
                        { value: '10', text: '大库转供应商' }
                    ]
                }
                },
                {
                key: 'financialRequired',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.financialRequired',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'target',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.target',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'financialLogin',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.financialLogin',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'financialApprovalTime',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.financialApprovalTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'logLogin',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.logLogin',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'logApprovalTime',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.logApprovalTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.inventory.sithMesInventoryChangeMaterialProject.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                        }
                }
        ]
        
        export {SithMesInventoryChangeMaterialProject, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        